/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "hourglass-760ae5dd--sprite",
  "use": "hourglass-760ae5dd--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"hourglass-760ae5dd--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(11.686 8.91)\"><path d=\"M38.046,36.173h-.284V34.08a6.257,6.257,0,0,0-1.3-3.839,6.342,6.342,0,0,0-2-1.71,6.451,6.451,0,0,0,2-1.71,6.27,6.27,0,0,0,1.3-3.844V20.884h.284a.551.551,0,1,0,0-1.1H26.524a.551.551,0,1,0,0,1.1h.284v2.093a6.27,6.27,0,0,0,1.3,3.844,6.451,6.451,0,0,0,2,1.71,6.342,6.342,0,0,0-2,1.71,6.257,6.257,0,0,0-1.3,3.839v2.093h-.284a.551.551,0,1,0,0,1.1H38.046a.551.551,0,1,0,0-1.1Zm-1.386,0H35.48c0-1.472-1.764-2.759-2.957-3.457V32.7l-.05-1.161q-.054-1.3,0-2.606l.068-1.535v-.027a4,4,0,0,0,2.664-2.426l-2.917.441H32.28l-2.916-.441a4,4,0,0,0,2.664,2.426V27.4l.068,1.535q.054,1.3,0,2.606l-.05,1.161v.018c-1.193.7-2.953,1.985-2.957,3.457H27.91V34.08a5.185,5.185,0,0,1,1.076-3.173,7.633,7.633,0,0,1,1.814-1.85c.194-.144.4-.284.4-.527s-.2-.387-.4-.531a6.68,6.68,0,0,1-1.814-1.85,5.185,5.185,0,0,1-1.076-3.173V20.884h8.749v2.093a5.185,5.185,0,0,1-1.076,3.173A6.68,6.68,0,0,1,33.77,28c-.2.144-.4.284-.4.531s.207.383.4.527a7.633,7.633,0,0,1,1.814,1.85,5.185,5.185,0,0,1,1.076,3.173Z\" transform=\"translate(-25.97 -19.781)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
